export default __webpack_public_path__ + "static/media/img-menu-new.5a9335a1.jpg";